import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "快速导航",
    links: [
      { to: "/", label: "首页" },
      { to: "/category", label: "电视剧分类" },
      { to: "/special", label: "相关剧集专题" },
      { to: "/about", label: "关于我们" },
    ],
  },
  {
    title: "热门剧集",
    links: [
      { to: "/detail/nanny", label: "迷人的保姆" },
      { to: "/detail/fog-trace", label: "迷雾追凶" },
      { to: "/detail/city-love", label: "都市迷情" },
      { to: "/detail/warm-sun", label: "暖阳之下" },
    ],
  },
  {
    title: "热门专题",
    links: [
      { to: "/special", label: "保姆与家庭题材精选" },
      { to: "/special", label: "都市情感热播剧场" },
      { to: "/special", label: "悬疑推理高分剧集" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="mx-auto grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-semibold text-background-50">迷人的保姆</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-200">
            专注电视剧《迷人的保姆》及同类题材的剧情介绍、角色解析与精彩片段回顾，为影迷提供贴心的追剧辅助。
          </p>
          <div className="mt-4 flex gap-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800 text-primary-100">
              <i className="ri-wechat-line text-base"></i>
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800 text-primary-100">
              <i className="ri-weibo-line text-base"></i>
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800 text-primary-100">
              <i className="ri-message-3-line text-base"></i>
            </span>
          </div>
        </div>

        {COLUMNS.map((column) => (
          <div key={column.title}>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">{column.title}</h4>
            <ul className="mt-4 space-y-2">
              {column.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-primary-800">
        <div className="mx-auto flex flex-col gap-2 px-4 py-5 text-xs text-primary-300 md:flex-row md:items-center md:justify-between md:px-6 lg:px-8">
          <p>© 2026 迷人的保姆 · 影视剧集资讯站 | 本站为内容演示站点，不含视频播放与下载功能</p>
          <p>站内剧情介绍与剧照仅供影迷交流参考，版权归原制作方所有</p>
        </div>
      </div>
    </footer>
  );
}